import {DefaultNodeModel, Toolkit} from "@projectstorm/react-diagrams";
import {merge} from 'lodash'
import {CustomPortModel} from "./CustomPortModel";

export class CustomNodeModel extends DefaultNodeModel {
    constructor(title, name, type, sectionType, number, diagram, blockDescription) {
        super({type: "custom"});
        this.title = title;
        this.name = name;
        this.nodeName = type;
        this.sectionType = sectionType;
        this.number = number;
        this.diagram = diagram;
        this.blockDescription = blockDescription;
    }

    addInPort(label) {
        let port = new CustomPortModel({
            in: true,
            name: Toolkit.UID(),
            label: label
        });
        return this.addPort(port);
    }

    addOutPort(label) {
        let port = new CustomPortModel({
            in: false,
            name: Toolkit.UID(),
            label: label
        });
        return this.addPort(port);
    }

    deSerialize(object, engine) {
        super.deSerialize(object, engine);
        this.name = object.name;
        this.title = object.title;
        this.color = object.color;
        this.nodeName = object.nodeName;
        this.sectionType = object.sectionType;
        this.number = object.number;
        this.extras = object.extras;
        this.blockDescription = object.blockDescription;
    }

    serialize() {
        return merge(super.serialize(), {
            name: this.name,
            title: this.title,
            color: this.color,
            nodeName: this.nodeName,
            sectionType: this.sectionType,
            number: this.number,
            extras: this.extras,
            blockDescription: this.blockDescription
        });
    }

    // showMenu(){
    // 	this.open = true;
    // 	console.log('show')
    // }

    // hideMenu(){
    // 	this.open =false
    // 	console.log('hide')
    // }

    // appendNode() {
    // 	let model = this.diagram.props.engine.getDiagramModel();
    // 	let selectedItem = model.getSelectedItems();
    // 	let newNode;
    // 	selectedItem.forEach((item) => {
    // 	console.log(item)
    // 	if (item instanceof NodeModel) {
    // 		newNode = new DefaultNodeModel(new Date().getTime(), "#FF0000");
    // 		let newInPort = newNode.addInPort('in')
    // 		let newOutport = newNode.addOutPort('out')
    // 		console.log(item.getOutPorts())
    // 		let newOutLink = item.getOutPorts()[0].link(newInPort)
    // 		newNode.setPosition(item.x, item.y + 100);
    // 		model.addAll(newNode, newOutLink)
    // 	}/*  else if (item instanceof PointModel) {
    // 		if (!item.parent.getSourcePort().in) {
    // 		console.log(item)
    // 		let nodeOutport = item.parent.getSourcePort();
    // 		let nodeOutTarget = item.parent.getTargetPort();
    // 		let newOutLink = newNode.getOutPorts()[0].link(nodeOutTarget)
    // 		console.log(nodeOutTarget)
    // 		console.log(newOutLink)
    // 		console.log( nodeOutTarget.getLinks())
    // 		item.remove()

    // 		model.addAll(newOutLink)

    // 		}
    // 	} */
    // 	});
    // 	this.diagram.forceUpdate();
    // }

}